import React, { ReactNode } from "react";
import { AuthProvider as OidcAuthProvider } from "react-oidc-context";
import { oidcSettings, userManager } from "../services/session";

// Debug environment variables
console.log("OIDC Environment Variables:", {
  authority: process.env.REACT_APP_OIDC_AUTHORITY,
  client_id: process.env.REACT_APP_OIDC_CLIENT_ID,
  client_secret: process.env.REACT_APP_OIDC_CLIENT_SECRET ? "[REDACTED]" : "not set",
  redirect_uri: process.env.REACT_APP_OIDC_REDIRECT_URI,
  post_logout_redirect_uri: process.env.REACT_APP_OIDC_POST_LOGOUT_REDIRECT_URI,
  scope: process.env.REACT_APP_OIDC_SCOPE,
});

// The settings and the UserManager live in `services/session.ts`, where the API clients use the
// same instance to renew tokens and to sign the user in again when the session has ended.
console.log("Final OIDC Config:", {
  ...oidcSettings,
  ...(oidcSettings.client_secret && { client_secret: "[REDACTED]" }),
});


interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  return (
    <OidcAuthProvider
      userManager={userManager}
      onSigninCallback={(user) => {
        console.log("OIDC: Sign in callback completed", user);
        // Don't manipulate history here - let React Router handle navigation
      }}
      onRemoveUser={() => {
        console.log("OIDC: User removed from storage");
      }}
    >
      {children}
    </OidcAuthProvider>
  );
};

export interface User {
  id?: string;
  name?: string;
  email?: string;
  roles?: string[];
  // OIDC standard claims
  given_name?: string;
  family_name?: string;
  preferred_username?: string;
  sub?: string;
  aud?: string;
  iss?: string;
  iat?: number;
  exp?: number;
}

export interface AuthContextType {
  user: User | null;
  isAuthenticated: boolean;
  login: () => void;
  logout: () => void;
  register: () => void;
}
